module.exports = __webpack_public_path__ + "static/media/promaint.31556114.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/clients/promaint.png
// module id = 896
// module chunks = 0